<template>
                <div v-if="currentView === 'departments'">
                    <div class="page-header"><div><div class="page-title">部門管理</div><div class="page-subtitle">建立與維護組織部門結構</div></div></div>
                    <div class="card p-6 mb-6">
                        <h3 class="card-title mb-3">新增部門</h3>
                        <div class="grid grid-cols-1 md:grid-cols-4 gap-2 items-end">
                            <div v-if="isSuperAdmin">
                                <label class="block text-xs font-medium mb-1" style="color:var(--gray-600)">網域</label>
                                <select v-model="newDepartment.domain_id" @change="fetchDepartments(newDepartment.domain_id)" class="input">
                                    <option v-for="(d, idx) in safeArr(domains)" :key="keyById(d, 'domain-opt3', idx)" :value="d.id">{{ d.name }}</option>
                                </select>
                            </div>
                            <div>
                                <label class="block text-xs font-medium mb-1" style="color:var(--gray-600)">部門名稱</label>
                                <input v-model="newDepartment.name" type="text" placeholder="例如：業務部"
                                    class="input">
                            </div>
                            <div>
                                <label class="block text-xs font-medium mb-1" style="color:var(--gray-600)">描述</label>
                                <input v-model="newDepartment.description" type="text" placeholder="可選"
                                    class="input">
                            </div>
                            <div class="md:col-span-4">
                                <div class="flex items-center justify-between mb-2">
                                    <label class="block text-xs">可使用功能</label>
                                    <div class="flex gap-2">
                                        <button @click="newDepartment.permission_keys = departmentPermissionOptions.map(x => x.key)" type="button"
                                            class="px-2 py-1 text-xs border rounded">
                                            全選
                                        </button>
                                        <button @click="newDepartment.permission_keys = []" type="button"
                                            class="px-2 py-1 text-xs border rounded">
                                            全不選
                                        </button>
                                    </div>
                                </div>
                                <div class="grid grid-cols-2 md:grid-cols-3 gap-2">
                                    <label v-for="opt in departmentPermissionOptions" :key="opt.key" class="flex items-center gap-2 text-sm">
                                        <input type="checkbox" :value="opt.key" v-model="newDepartment.permission_keys">
                                        <span>{{ opt.label }}</span>
                                    </label>
                                </div>
                            </div>
                            <button @click="addDepartment"
                                class="btn btn-primary mb-0.5">建立</button>
                        </div>
                    </div>
                    <div class="card p-6">
                        <table class="data-table">
                            <thead>
                                <tr class="border-b">
                                    <th class="p-2">ID</th>
                                    <th class="p-2">部門</th>
                                    <th class="p-2">網域</th>
                                    <th class="p-2">描述</th>
                                    <th class="p-2">功能</th>
                                    <th class="p-2">操作</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(dept, idx) in safeArr(departments)" :key="keyById(dept, 'dept-row', idx)" class="border-b">
                                    <td class="p-2">{{ dept.id }}</td>
                                    <td class="p-2">{{ dept.name }}</td>
                                    <td class="p-2">{{ getDomainName(dept.domain_id) || dept.domain_id }}</td>
                                    <td class="p-2">{{ dept.description || '-' }}</td>
                                    <td class="p-2">
                                        <span v-if="formatDepartmentPermissions(dept).length === 0" style="color:var(--gray-400);">（未設定）</span>
                                        <span v-else class="text-xs" style="color:var(--gray-700);">{{ formatDepartmentPermissions(dept).join('、') }}</span>
                                    </td>
                                    <td class="p-2">
                                        <button @click="startEditDepartment(dept)" class="text-sm mr-2" style="color:var(--primary);">編輯</button>
                                        <button @click="deleteDepartment(dept.id)" class="btn btn-ghost btn-xs" style="color:var(--color-danger)">刪除</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- Edit Department Modal -->
                <div v-if="editingDepartment" class="fixed inset-0 flex items-center justify-center" style="background:rgba(0,0,0,0.5);">
                    <div class="card p-6 w-96">
                        <h3 class="card-title mb-4">編輯部門</h3>
                        <div class="space-y-4">
                            <div>
                                <label class="block text-sm">部門名稱</label>
                                <input v-model="editDepartmentForm.name" type="text" class="w-full border p-2 rounded">
                            </div>
                            <div>
                                <label class="block text-sm">描述</label>
                                <input v-model="editDepartmentForm.description" type="text" class="w-full border p-2 rounded">
                            </div>
                            <div>
                                <div class="flex items-center justify-between mb-2">
                                    <label class="block text-sm">可使用功能</label>
                                    <div class="flex gap-2">
                                        <button @click="editDepartmentForm.permission_keys = departmentPermissionOptions.map(x => x.key)" type="button"
                                            class="btn btn-outline btn-xs">
                                            全選
                                        </button>
                                        <button @click="editDepartmentForm.permission_keys = []" type="button"
                                            class="btn btn-outline btn-xs">
                                            全不選
                                        </button>
                                    </div>
                                </div>
                                <div class="grid grid-cols-2 gap-2">
                                    <label v-for="opt in departmentPermissionOptions" :key="opt.key" class="flex items-center gap-2 text-sm">
                                        <input type="checkbox" :value="opt.key" v-model="editDepartmentForm.permission_keys">
                                        <span>{{ opt.label }}</span>
                                    </label>
                                </div>
                            </div>
                            <div class="flex justify-end gap-2">
                                <button @click="editingDepartment = null" class="px-4 py-2 border rounded">取消</button>
                                <button @click="updateDepartment" class="btn btn-primary">儲存</button>
                            </div>
                        </div>
                    </div>
                </div>


</template>

<script setup>
import { storeToRefs } from 'pinia'
import { useAppStore } from '../store/app.js'

const store = useAppStore()

// Spread all store state as reactive refs accessible in template
const stateRefs = storeToRefs(store)
// Destructure - Vue compiler exposes all variables declared in <script setup> to template
const {
  // Core state
  token, currentView, currentUser, loginForm, loginError,
  branding, notifications, showNotifPanel,
  // Command palette
  showCmdPalette, cmdQuery, cmdResults, cmdGrouped, cmdDefaults, cmdSelIdx,
  // Domain / Users / Departments
  domains, domainForm, showDomainForm, domainLoading,
  users, userForm, showUserForm, userLoading, userError,
  departments, deptForm, showDeptForm, deptLoading,
  // Contacts / Groups
  contacts, contactForm, showContactForm, contactLoading,
  groups, groupForm, showGroupForm, groupLoading,
  // Mail
  mailQueues, mailQueueLoading, mailQueueFilter,
  serviceStatus, serviceLoading,
  // Invoice Drive
  invoiceDriveState,
  // Quotes / Products
  quotes, quoteForm, showQuoteForm, quoteLoading,
  products, productForm, showProductForm, productLoading,
  priceBooks, priceBookForm, showPriceBookForm,
  // SSL
  sslCerts, sslLoading, sslDomain,
  // Security
  securityWizardStep, spamStats,
  securityFilterState,
  // Server settings
  serverMailSettings, serverDnsSettings, serverDbSettings, serverAiSettings,
  backupSettings,
  // Logs / Audit
  logs, logFilter, logLoading,
  mailAuditRecords, auditFilter, auditLoading,
  securityAuditLogs, securityAuditFilter,
  logAnalysisResult, logAnalysisLoading,
  // AI / RAG / Sales
  ragState, aiSalesState, aiMarketingState,
  // LINE
  lineSupportState,
  // Webmail
  webmailState, webmailAutoScanInvoices, webmailAutoScanMarkRead,
  // Unreplied
  unrepliedEmails, unrepliedLoading,
  // CBI
  cbiInsights, cbiLoading,
  // Misc
  sidebarCollapsed, sidebarMobile,
  journeyEnrollments, journeyEnrollmentsLoading,
  journeyFunnel, journeyFunnelLoading, journeyFunnelFilters,
  showJourneyEditorModal, showJourneyFunnelModal, showJourneyEnrollmentsModal,
  selectedJourneyForEnrollments, selectedJourneyForFunnel,
  journeyEditorForm,
  newDepartment, isSuperAdmin, isDomainAdmin,
  departmentPermissionOptions, editingDepartment, editDepartmentForm,
} = stateRefs

// Methods are accessed directly from store (not reactive, no storeToRefs needed)
const {
  login, logout, switchSidebarView, canAccess,
  openCommandPalette, closeCmdPalette, updateCmdResults, execCmdItemById,
  moveCmdSel, toggleNotifPanel, markNotifRead, clearNotifs,
  fetchDomains, saveDomain, deleteDomain,
  fetchUsers, saveUser, deleteUser, resetUserPassword,
  fetchDepartments, saveDepartment, deleteDepartment,
  fetchContacts, saveContact, deleteContact, importContacts,
  fetchGroups, saveGroup, deleteGroup,
  fetchMailQueue, releaseMailQueueItem, deleteMailQueueItem, flushMailQueue,
  fetchServiceStatus, fetchSpamStats,
  fetchSslCerts, issueSslCert, deleteSslCert,
  fetchProducts, saveProduct, deleteProduct,
  fetchPriceBooks, savePriceBook, deletePriceBook,
  fetchQuotes, saveQuote, deleteQuote, sendQuote,
  fetchLogs, fetchLogAnalysis,
  fetchMailAuditRecords, fetchSecurityAuditLogs,
  fetchServerMailSettings, saveServerMailSettings,
  fetchServerDnsSettings, saveServerDnsSettings,
  fetchServerDbSettings, saveServerDbSettings,
  fetchServerAiSettings, saveServerAiSettings,
  fetchBackupSettings, saveBackupSettings, triggerBackup,
  fetchSecurityFilter, saveSecurityFilter,
  fetchRagDocuments, uploadRagDocument, deleteRagDocument, queryRag,
  fetchUnreplied,
  fetchCbiInsights,
  loadBrandingFromLocal, saveBranding,
  safeArr, keyById,
  invoiceDriveCanGotoAdjacent, invoiceDriveGotoAdjacent,
  openInvoiceDetail, closeInvoiceDetail,
  addDepartment, startEditDepartment, updateDepartment, getDomainName, formatDepartmentPermissions,
} = store
</script>

